var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-theme-provider",
    {
      attrs: {
        dark: _vm.effectiveAppearance === "dark",
        light: _vm.effectiveAppearance === "light"
      }
    },
    [
      _vm.isReady
        ? _c(
            "div",
            {
              key: _vm.refreshKey,
              class: [
                _vm.inFrame ? "outer-wrapper-in-frame" : "outer-wrapper",
                "column-format",
                "align-center",
                "main-form",
                { "mx-brand-form-surface": _vm.resolvedBranding }
              ].concat(_vm.brandClasses),
              style: _vm.formStyle,
              attrs: { id: _vm.brandTargetId }
            },
            [
              !_vm.complete
                ? _c(
                    "div",
                    {
                      staticClass: "form-v2-content mx-brand-form",
                      style:
                        "width:100%; min-width: 300px; max-width: " +
                        _vm.styles.maxWidth +
                        "px"
                    },
                    [
                      _vm._l(_vm.pages[_vm.currentPage], function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isItemVisible(item),
                                expression: "isItemVisible(item)"
                              }
                            ],
                            key: item.id,
                            attrs: { id: item.id }
                          },
                          [
                            _c("item-renderer", {
                              ref: "item",
                              refInFor: true,
                              attrs: {
                                index: index + (_vm.currentPage + 1) * 1000,
                                item: item,
                                styles: _vm.styles,
                                font: _vm.font,
                                "button-props": _vm.buttonProps,
                                disabled: _vm.disabled,
                                "current-page": _vm.currentPage + 1,
                                "page-count": _vm.pages.length,
                                "account-logo": _vm.accountLogo,
                                active: false,
                                results: _vm.results,
                                "known-data": _vm.defaultContact
                              },
                              on: {
                                "next-page": function($event) {
                                  return _vm.nextPage()
                                },
                                "previous-page": function($event) {
                                  return _vm.previousPage()
                                },
                                input: function($event) {
                                  return _vm.handleInput($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm.isLastPage
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row-format gap-2 pt-2 px-2 mx-brand-button-row",
                                style:
                                  "width: 100%; justify-content: " +
                                  _vm.justification
                              },
                              [
                                _vm.pages.length > 1
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "elevation-0 mx-secondary-button",
                                        style:
                                          "font-size: var(--form-font-size) !important; " +
                                          (_vm.buttonProps.block
                                            ? "width: 49%!important;"
                                            : ""),
                                        attrs: {
                                          color: _vm.styles.buttonColor,
                                          "x-small": _vm.buttonProps.xSmall,
                                          small: _vm.buttonProps.small,
                                          large: _vm.buttonProps.large,
                                          "x-large": _vm.buttonProps.xLarge
                                        },
                                        on: { click: _vm.previousPage }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            attrs: {
                                              color: _vm.styles.buttonTextColor
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.styles.prevPageIcon)
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            style:
                                              "font-family: " +
                                              _vm.font +
                                              "; ; text-transform: none; color: " +
                                              _vm.styles.buttonTextColor
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.styles.prevPageText)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "elevation-0 mx-primary-button",
                                    style:
                                      "font-size: var(--form-font-size) !important; " +
                                      (_vm.pages.length > 1 &&
                                      _vm.buttonProps.block
                                        ? "width: 49%!important;"
                                        : ""),
                                    attrs: {
                                      color: _vm.styles.buttonColor,
                                      "x-small": _vm.buttonProps.xSmall,
                                      small: _vm.buttonProps.small,
                                      large: _vm.buttonProps.large,
                                      "x-large": _vm.buttonProps.xLarge,
                                      block:
                                        _vm.pages.length === 1 &&
                                        _vm.buttonProps.block,
                                      disabled: _vm.disabled
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.submitForm()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        style:
                                          "font-family: " +
                                          _vm.font +
                                          "; ; text-transform: none; color: " +
                                          _vm.styles.buttonTextColor
                                      },
                                      [_vm._v(_vm._s(_vm.styles.submitText))]
                                    ),
                                    _vm.styles.submitIcon
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass:
                                              "ml-1 material-symbols-outlined",
                                            attrs: {
                                              color: _vm.resolvedBranding
                                                ? _vm.resolvedBranding.buttons
                                                    .text
                                                : _vm.effectiveAppearance ===
                                                  "dark"
                                                ? "black"
                                                : _vm.styles.buttonTextColor
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.styles.submitIcon)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-v2-recaptcha font-gray_60 mx-brand-help"
                              },
                              [
                                _vm._v(
                                  " This page is protected by reCAPTCHA and the Google "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "https://policies.google.com/privacy"
                                    }
                                  },
                                  [_vm._v("Privacy Policy")]
                                ),
                                _vm._v(" and "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://policies.google.com/terms"
                                    }
                                  },
                                  [_vm._v("Terms of Service")]
                                ),
                                _vm._v(" apply. ")
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _c("div", { staticClass: "mx-brand-form" }, [
                    _c("div", {
                      staticClass: "mx-brand-rich-text",
                      domProps: { innerHTML: _vm._s(_vm.confirmationHtml) }
                    })
                  ]),
              _c(
                "v-snackbar",
                {
                  attrs: { top: "", color: "gray_80", timeout: 5000 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "action",
                        fn: function(ref) {
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._b(
                                {
                                  attrs: { color: "error", text: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.showError = false
                                    }
                                  }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              [_vm._v(" OK ")]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    441339782
                  ),
                  model: {
                    value: _vm.showError,
                    callback: function($$v) {
                      _vm.showError = $$v
                    },
                    expression: "showError"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.errorText) + " ")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }